import styled from 'styled-components';

export default styled.span`
  @media (orientation: landscape) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/PortraitOnly/PortraitOnly.js